module.exports = __webpack_public_path__ + "img/exmple-3.8b8bd2d5.png";